var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'loading-wrapper',
    _vm.fullscreen ? 'position-fixed top-0 start-0 w-100 h-100' : '',
    _vm.blur ? 'backdrop-blur' : '',
  ]},[_c('div',{staticClass:"spinner-container"},[_c('b-spinner',{attrs:{"variant":_vm.variant,"type":_vm.spinnerType}}),(_vm.showLabel)?_c('div',{staticClass:"mt-2 loading-label"},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }